import React, { FC, useRef, useEffect } from "react"
import { useCreation } from "ahooks"
import { EChartOption } from "echarts"
import Echart from "@components/Echart"
import { accMul } from "@util/util"
import Env from "@util/env"
import "./index.scss"

type IGraphProps = {
  data: { value: number; name: string }[]
}
var color = [
  "#5886F8",
  "#F8C969",
  "#4BC9AC",
  "#F8775A",
  "#BD81DE",
  "#FF88D5",
  "#8B69FF",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
]
const TreeMap: FC<IGraphProps> = ({ data }) => {
  const ref = useRef()

  const option = useCreation<EChartOption>(() => {
    return {
      legend: { show: false },
      tooltip: {
        trigger: "item",
        formatter: function (params: any) {
          const { name, value } = params.data
          return `${name}: ${accMul(value, 100)}%`
        },
      },
      color: color,
      series: [
        {
          type: "treemap",
          width: "100%",
          height: "90%",
          breadcrumb: { show: false },
          roam: false,
          nodeClick: false,
          data: data,
          label: {
            show: true,
            // @ts-ignore
            fontSize: Env.getScale() * 14,
            // formatter: function (params: any) {
            //   const { name, value } = params.data
            //   return `${name}: ${round(value * 100, 2)}%`
            // },
          },
        },
      ],
    }
  }, [data])
  useEffect(() => {
    return () => {
      // @ts-ignore
      ref.current && ref.current.getEchartsInstance().dispose()
    }
  }, [ref])
  return (
    <div className="ct-tree-map" style={{ height: "100%" }}>
      <Echart $ref={ref} option={option} />
    </div>
  )
}

export default TreeMap
